export const domains = {
    local: {
        recruiters: 'http://localhost:3010',
    },
    prod: {
        recruiters: 'https://recruiters.becrosspath.com',
    },
} as const;

export const getRecruitersAppUrl = (currentOrigin?: string) => {
    if (!currentOrigin && typeof window !== 'undefined') currentOrigin = window.location.origin;

    if (currentOrigin) {
        const { hostname, port } = new URL(currentOrigin);
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            const localPort = Number(port);
            if (Number.isInteger(localPort) && localPort > 1) return `http://${hostname}:${localPort - 1}`;
            return domains.local.recruiters;
        }
    }

    return domains.prod.recruiters;
};
